var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.895,
    height: 21,
    viewBox: "0 0 19.895 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-city",
    "data-name": "Icon material-location-city",
    d: "M17.763,12.947V6.316L14.447,3,11.132,6.316V8.526H4.5V24H24.395V12.947ZM8.921,21.789H6.711V19.579H8.921Zm0-4.421H6.711V15.158H8.921Zm0-4.421H6.711V10.737H8.921Zm6.632,8.842H13.342V19.579h2.211Zm0-4.421H13.342V15.158h2.211Zm0-4.421H13.342V10.737h2.211Zm0-4.421H13.342V6.316h2.211Zm6.632,13.263H19.974V19.579h2.211Zm0-4.421H19.974V15.158h2.211Z",
    transform: "translate(-4.5 -3)",
    fill: "#b2b1b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.de8bfb57b5a6237d9a3df60af27e1c60.svg";
export { ForwardRef as ReactComponent };